module.exports = __webpack_public_path__ + "static/media/Sage-min.dfa2dba4.PNG";